'use strict';

var RemoteModelInterface = require('./RemoteModelInterface');
var linkUtils = require('./linkUtils');
var uriUtils = require('./uriUtils');
var richTextUtils = require('./richTextUtils');
var videoUrlsUtils = require('./videoUrlsUtils/videoUrlsUtils');
var repeaterUtils = require('./repeaterUtils/repeaterUtils');
var TypeUtils = require('./typeUtils/typeUtils');
var backgroundUtils = require('./backgroundUtils');
var svgUtils = require('./svgUtils');
var typeData = require('./typeUtils/typeData');
var componentsHooks = require('./RMIHooks/componentsHooks');

module.exports = {
  RemoteModelInterface: RemoteModelInterface,
  linkUtils: linkUtils,
  uriUtils: uriUtils,
  richTextUtils: richTextUtils,
  videoUrlsUtils: videoUrlsUtils,
  repeaterUtils: repeaterUtils,
  backgroundUtils: backgroundUtils,
  svgUtils: svgUtils,
  componentsHooks: componentsHooks,
  typeUtils: new TypeUtils(typeData)
};


// WEBPACK FOOTER //
// ./~/santa-platform-utils/lib/main.js